import React, { Component } from 'react';
import ProductItem from '../../product-item';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from 'react-accessible-accordion';
import { connect } from 'react-redux';
import { setExpandedItems } from '../../../redux/paragraph-shop-products-actions';

class ParagraphShopProducts extends Component {
  // This handler is triggered on each item collapse/expand.
  // Here the global Redux store gets updated to hold the currently opened item.
  handleAccordionChange = () => {
    // As per definition this component always contains only one Accordion item,
    // we can use the id (this.props.id) of the paragraph as the Accordion item id.
    const itemId = this.props.id
    const expandedItems = this.props.expandedItems
    const setExpandedItems = this.props.setExpandedItems

    const newExpandedItems = expandedItems.includes(itemId) ? [] : [itemId];

    // Update the global store/state.
    setExpandedItems(newExpandedItems);
  };

  render() {
    // Decide if this Accordion (item) should be expanded according to global state.
    const isExpanded = this.props.expandedItems.includes(this.props.id)

    // Scroll to active accordion.
    if (isExpanded) {
      const element = document.getElementById('accordion__heading-' + this.props.id);
      element.scrollIntoView({ behavior: 'smooth' });
    }

    return (
      <div className="container">
        <Accordion allowZeroExpanded onChange={this.handleAccordionChange}>
          <AccordionItem uuid={this.props.id} dangerouslySetExpanded={isExpanded}>
            <AccordionItemHeading>
              <AccordionItemButton style={{ backgroundColor: this.props.content.backgroundColor ?? 'white' }}>
                {this.props.content.headline}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="container">
                <div className="row">
                  {this.props.content.entities.map((item, index) =>
                    <div className="col col-12 col-lg-4 py-3">
                      <ProductItem product={item}/>
                    </div>
                  )}
                </div>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    );
  }
}

// Map the global state from store to local props (to control this component).
const mapStateToProps = (state) => ({
  expandedItems: state.shopAccordionStore.expandedItems,
});

const mapDispatchToProps = {
  setExpandedItems,
};

export default connect(mapStateToProps, mapDispatchToProps)(ParagraphShopProducts);
